export const extractNumber = (value) => {
  if (!value) return 0;

  const match = value.toString().match(/-?\d+(\.\d+)?/);
  return match ? parseFloat(match[0]) : 0;
};

export const formatAmount = (amount) => {
  const cleanAmount = extractNumber(amount);
  return cleanAmount
    ? Math.round(cleanAmount).toLocaleString('en-KE', { minimumFractionDigits: 0 })
    : '0';
};